module.exports = __webpack_public_path__ + "img/ic_medium_podcast-active.3ac88887.svg";